// Draft of the registration form, kept in sessionStorage (cleared when the tab closes).
const KEY = 'mt-2027-draft';

export function loadDraft() {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveDraft(values, step) {
  try {
    const { paymentDetails = {}, ...rest } = values;
    const { acceptTerms, ...payment } = paymentDetails; // consent is given fresh each time
    window.sessionStorage.setItem(
      KEY,
      JSON.stringify({ values: { ...rest, paymentDetails: payment }, step }),
    );
  } catch {
    /* storage unavailable: the form just works without a draft */
  }
}

export function clearDraft() {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

// Saved answers laid over the defaults; keys the form no longer has are dropped.
export function mergeDefaults(defaults, saved) {
  if (!saved) return defaults;
  return Object.fromEntries(
    Object.entries(defaults).map(([group, fields]) => [
      group,
      Object.fromEntries(
        Object.entries(fields).map(([k, v]) => [k, saved[group]?.[k] ?? v]),
      ),
    ]),
  );
}
